import { ExportFill } from "../../../../../assets";
import { Icon } from "../../../../icon";
import "./exportdata.css";
import { OperationExportDataProps } from "./exportdata.props";

const OperationExportData: React.FC<OperationExportDataProps> = ({
  show,
  icon,
  text,
  disabled = false,
  className,
  onClick,
}) => {
  return (
    <>
      {show && (
        <button
          className={`operation-exportdata-button ${
            disabled ? "disabled" : ""
          } ${className}`}
          onClick={onClick}
          disabled={disabled}
        >
          <Icon
            icon={icon ?? ExportFill}
            alt="Icon export"
            className="operation-filter-button-icon"
          />
          <p>{text}</p>
        </button>
      )}
    </>
  );
};

export default OperationExportData;
